/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { BackupPolicyExpression } from '../models/BackupPolicyExpression';
import { LogicalOperator } from '../models/LogicalOperator';

/**
* Group of expressions to evaluate using the logical operator specified in `operator`. Each item in the `operands` list can be either a single expression or a nested `group` expression. 
*/
export class BackupPolicyGroupCondition {
  'operator': LogicalOperator;
  /**
  * List of expressions to evaluate using the logical operator specified in `operator`. Each item in the list can be either a single expression or a nested `group` expression.  Must contain at least 2 items. 
  */
  'operands': Array<BackupPolicyExpression>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "operator",
      "baseName": "operator",
      "type": "LogicalOperator",
      "format": ""
    },
    {
      "name": "operands",
      "baseName": "operands",
      "type": "Array<BackupPolicyExpression>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return BackupPolicyGroupCondition.attributeTypeMap;
  }

  public constructor() {
  }
}



